import { useCallback, useContext } from 'react'
import { ProjectContext, UserContext } from '../../contexts'
import { Table, useSearchTableQueryState } from '../../components'
import api from '../../api'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import Menu, { MenuItem } from '../../ui/Menu'
import { EyeIcon } from '../../ui/icons'

export default function UserDetailNotifications() {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const [project] = useContext(ProjectContext)
    const [user] = useContext(UserContext)

    const projectId = project.id
    const userId = user.id

    const state = useSearchTableQueryState(useCallback(async params => await api.users.notifications(projectId, userId, params), [projectId, userId]))

    return (
        <Table
            {...state}
            title={t('notifications')}
            description={t('notifications_desc')}
            columns={[
                {
                    key: 'campaign_name',
                    title: t('campaign'),
                },
                {
                    key: 'created_at',
                    title: t('sent_at'),
                },
                {
                    key: 'read_at',
                    title: t('read_at'),
                },
                {
                    key: 'expires_at',
                    title: t('expires_at'),
                },
                {
                    key: 'options',
                    title: t('options'),
                    align: 'end',
                    cell: ({ item }) => !item.read_at && (
                        <Menu size="small">
                            <MenuItem
                                icon={<EyeIcon />}
                                onClick={async () => {
                                    await api.users.readNotification(projectId, userId, item.id)
                                    await state.reload()
                                }}
                            >
                                {t('mark_as_viewed')}
                            </MenuItem>
                        </Menu>
                    ),
                },
            ]}
            onSelectRow={async n => {
                if (!n.campaign_id) return
                await navigate(`../../campaigns/${n.campaign_id}`)
            }}
        />
    )
}
